export enum TrackerVariableTypeMobile {
  IS_SIMULATOR = 'IS_SIMULATOR',
  DEVICE_MODEL = 'DEVICE_MODEL',
  IS_ROOTED = 'IS_ROOTED',
  RAM_SIZE = 'RAM_SIZE',
  APP_STATE = 'APP_STATE',
  ORIENTATION = 'ORIENTATION',
  BATTERY_LEVEL = 'BATTERY_LEVEL',
  ARCH = 'ARCH',
  BRIGHTNESS = 'BRIGHTNESS',
  RESOLUTION_WIDTH = 'RESOLUTION_WIDTH',
  RESOLUTION_HEIGHT = 'RESOLUTION_HEIGHT',
  IS_PHONE = 'IS_PHONE',
  IS_TABLET = 'IS_TABLET',
  LANGUAGE = 'LANGUAGE',
  REGION = 'REGION',
  TIME_ZONE = 'TIME_ZONE',
  ELAPSED_TIME = 'ELAPSED_TIME',
  UNIQUE_DEVICE_ID = 'UNIQUE_DEVICE_ID',
  REACHABLE = 'REACHABLE',
  NETWORK_TYPE = 'NETWORK_TYPE',
  IP_ADDRESS = 'IP_ADDRESS',
  MAC_ADDRESS = 'MAC_ADDRESS',
  CARRIER = 'CARRIER',
  CALL_DURATION = 'CALL_DURATION',
  CALL_IS_INCOMING = 'CALL_IS_INCOMING',
  CALL_NUMBER = 'CALL_NUMBER',
  IS_CONTACT = 'IS_CONTACT',
  SCREEN_RECORD_DURATION = 'SCREEN_RECORD_DURATION',
  SCREEN_RECORD_STATUS = 'SCREEN_RECORD_STATUS',
  LAST_KNOWN_LAT = 'LAST_KNOWN_LAT',
  LAST_KNOWN_LON = 'LAST_KNOWN_LON',
  CUSTOM_TRIGGER_ARGS = 'CUSTOM_TRIGGER_ARGS',
  GYRO_X = 'GYRO_X',
  GYRO_Y = 'GYRO_Y',
  GYRO_Z = 'GYRO_Z',
  TILT_STATUS = 'TILT_STATUS',
  CURRENT_TRIGGER_NAME = 'CURRENT_TRIGGER_NAME',
  CONTACT_LIST = 'CONTACT_LIST',
  APP_LIST = 'APP_LIST',
  PLATFORM = 'PLATFORM',
  SCREEN_SHARE_DURATION = 'SCREEN_SHARE_DURATION',
  SCREEN_SHARE_STATUS = 'SCREEN_SHARE_STATUS',
  IS_IN_VOIP_CALL = 'IS_IN_VOIP_CALL',
  WIFI_SSID = 'WIFI_SSID',
  IS_VPN = 'IS_VPN',
  IS_IN_CALL = 'IS_IN_CALL',
  THEME_MODE = 'THEME_MODE',
  CHARGING_TYPE = 'CHARGING_TYPE',
  IS_CHARGING = 'IS_CHARGING',
  APP_SIGNATURE_HASH = 'APP_SIGNATURE_HASH',
  SIM_SERIAL_HASH = 'SIM_SERIAL_HASH',
  IS_DEBUGGER_ATTACHED = 'IS_DEBUGGER_ATTACHED',
  REMOTE_SESSION_STATUS = 'REMOTE_SESSION_STATUS',
   RUNTIME_TAMPERED = 'RUNTIME_TAMPERED',
   COUNTRY = 'COUNTRY',
   ANDROID_ID = 'ANDROID_ID',
   CDID = 'CDID',
   NODE_NAME = 'NODE_NAME',
   OS_VERSION = 'OS_VERSION',
   PHONE_RADIO_VERSION = 'PHONE_RADIO_VERSION',
   PHONE_HOST = 'PHONE_HOST',
   HAS_X86_ABI = 'HAS_X86_ABI',
   STAGEFRIGHT_VULNERABLE = 'STAGEFRIGHT_VULNERABLE',
   ADB_ENABLED = 'ADB_ENABLED',
   SELINUX_STATUS = 'SELINUX_STATUS',
   REMOTE_CONTROL_ACTIVE = 'REMOTE_CONTROL_ACTIVE',
   EMULATOR_FAMILY = 'EMULATOR_FAMILY',
   FRIDA_DETECTED = 'FRIDA_DETECTED',
   GPS_ACCURACY_HORIZONTAL = 'GPS_ACCURACY_HORIZONTAL',
  GPS_ACCURACY_VERTICAL='GPS_ACCURACY_VERTICAL',  
  GPS_ALTITUDE='GPS_ALTITUDE', 
  GPS_BEARING='GPS_BEARING', 
  GPS_SPEED='GPS_SPEED',
  GPS_PROVIDER ='GPS_PROVIDER',
  WIFI_BSSID ='WIFI_BSSID',
  WIFI_CHANNEL ='WIFI_CHANNEL',
  WIFI_FREQUENCY ='WIFI_FREQUENCY',
  WIFI_SIGNAL_STRENGTH ='WIFI_SIGNAL_STRENGTH',
  CELL_ID='CELL_ID',
  CELL_LAC ='CELL_LAC',
  CELL_SIGNAL_STRENGTH ='CELL_SIGNAL_STRENGTH',
  CELL_NETWORK_TYPE='CELL_NETWORK_TYPE',
  HAS_ESIM_SUPPORT = 'HAS_ESIM_SUPPORT',
  IS_USING_ESIM ='IS_USING_ESIM',
  SIM_SLOT_COUNT ='SIM_SLOT_COUNT',
  ACTIVE_SUBSCRIPTION_COUNT ='ACTIVE_SUBSCRIPTION_COUNT',
  IS_OVERLAY_DETECTED ='IS_OVERLAY_DETECTED',
  CAN_DRAW_OVERLAYS ='CAN_DRAW_OVERLAYS',
  SDK_VERSION = "SDK_VERSION",
  TIMESTAMP = "TIMESTAMP",
  BEHAVIORAL_BIOMETRIC_FLAGS = "BEHAVIORAL_BIOMETRIC_FLAGS",
  BEHAVIORAL_BIOMETRIC_SCORE = "BEHAVIORAL_BIOMETRIC_SCORE",
  SESSION_BEHAVIOR = "SESSION_BEHAVIOR",
  SCROLL_BEHAVIOR = "SCROLL_BEHAVIOR",
  SWIPE_DYNAMICS = "SWIPE_DYNAMICS",
  TOUCH_DYNAMICS = "TOUCH_DYNAMICS",
}

export enum TrackerVariableTypeWeb {
  URL = 'URL',
  ELEMENT = 'ELEMENT',
  COOKIE = 'COOKIE',
  JAVASCRIPT = 'JAVASCRIPT',
  EVENT = 'EVENT',
  CUSTOM = 'CUSTOM',
  IP_ADDRESS = 'IP_ADDRESS',
  DEVICE_FINGERPRINT = 'DEVICE_FINGERPRINT',
  SUSPICIOUS_ACTIVITY = 'SUSPICIOUS_ACTIVITY',
  SUSPICIOUS_BROWSER = 'SUSPICIOUS_BROWSER',
  LANGUAGE = 'LANGUAGE',
  TIMEZONE = 'TIMEZONE',
  OS = 'OPERATING_SYSTEM',
  BROWSER = 'BROWSER',
  SCREEN_RESOLUTION = 'SCREEN_RESOLUTION',
  USER_AGENT = 'USER_AGENT',
  REMOTE_ACCESS_SCORE = 'REMOTE_ACCESS_SCORE',
  REMOTE_ACCESS_FLAGS_JSON = 'REMOTE_ACCESS_FLAGS_JSON',
  ENVIRONMENT_CHANGE_FLAGS = 'ENVIRONMENT_CHANGE_FLAGS',
  ENVIRONMENT_CHANGE_SCORE = 'ENVIRONMENT_CHANGE_SCORE',
  NO_MOUSE_MOVE_DURATION_MS = 'NO_MOUSE_MOVE_DURATION_MS',
  CLICK_ONLY_PATTERN = 'CLICK_ONLY_PATTERN',
  FAST_PAGE_TRANSITION = 'FAST_PAGE_TRANSITION',
  FORM_FILL_ANOMALY = 'FORM_FILL_ANOMALY',
  FORM_FILL_DURATION_MS = 'FORM_FILL_DURATION_MS',
  NAVIGATION_VELOCITY = 'NAVIGATION_VELOCITY',
  INPUT_PASTE_RATIO = 'INPUT_PASTE_RATIO',
  HEADLESS_INDICATOR_COUNT = 'HEADLESS_INDICATOR_COUNT',
  SDK_VERSION = "SDK_VERSION",
  TIMESTAMP = "TIMESTAMP",
}
